// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21b6044c","732":"31ebc544","977":"09e632cd"}[chunkId] + ".chunk.js";
};